import { gql } from '@apollo/client'
import {
  OrbitalTrackLiteFragment,
  OrbitalTrackSettingFragment
} from '@src/graphql/fragment/orbitalTrack'
import { PageInfoFragment } from '@src/graphql/fragment/pageInfo'

export default gql`
  query GetOrbitalTracks(
    $filterInput: GetOrbitalTrackFilterInput!
    $sortBy: OrbitalTrackSortBy!
    $pagingInput: PagingInput!
  ) {
    getOrbitalTracks(
      filterInput: $filterInput
      sortBy: $sortBy
      pagingInput: $pagingInput
    ) {
      pageInfo {
        ...PageInfo
      }
      edges {
        cursor
        node {
          ...OrbitalTrackLite
        }
      }
    }
  }
  ${PageInfoFragment}
  ${OrbitalTrackLiteFragment}
  ${OrbitalTrackSettingFragment}
`
